<template>
  <div class="modal" id="renameViewModal" tabindex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="renameViewModal"> RENAME DASHBOARD VIEW</h5>
          <div class="close-container myfaBtn" data-bs-dismiss="modal" aria-label="Close">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body modal-bodyHt mdclr">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group formpddr">
                <label class="col-sm-6 formpddl">Enter New Name</label>
                <input class="form-control col-sm-12" type="text" v-model="ViewName" maxlength="50" autofocus>
              </div>
            </div>
            <div class="col-sm-12">
              <label class="text-danger" v-show="isExist"><b>"{{ ViewName }}"</b> already exists, Please choose a different
                name.</label>
            </div>
          </div>
        </div>
        <div class="modal-footer footbdr">
          <div class="effect btn-save eff-md" v-on:click="ok()">Save</div>
          <div class="btn stdBtn btn-bordered" data-bs-dismiss="modal" type="button"><b>cancel</b></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
  name: 'renameviewMod',
  props: {
    isExist: Boolean
  },
  data() {
    return {
      modal: undefined,
      ViewID: "",
      ViewName: "",
    }
  },
  methods: {
    showReviewModal(id, name) {
      this.modal.show()
      this.ViewID = id
      this.ViewName = name
    },
    ok() {
      if (this.ViewName == undefined || this.ViewName == "") {
        this.$notify({ type: "warn", text: 'Please Provide the View Name' })
      } else {
        if (/^[A-Za-z0-9\s_-]+$/.test(this.ViewName) == false) {
          this.$notify({ type: "warn", text: 'View Name Should not contain special characters' })
        }
        else{
          this.$emit("renamedView", 1, this.ViewID, this.ViewName)
        }

      }
    },
    close() {
      this.modal.hide()
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById('renameViewModal'))
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formpddr {
  padding-right: 10px;
}

.formpddl {
  padding-left: 0px;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>
